import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Image,
  Text,
  Container,
  Flex,
  VStack,
  Stack,
  Link,
  Spacer,
} from '@chakra-ui/react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { BtNavigate } from '../../components/BtNavigate';
import { ApplyScreen } from './applyScreen';
import { images } from '../../support/imageSupport';
import BtButton from '../../components/BtButton';
import BtInput from '../../components/BtInput';
import BtGroup from '../../components/BtGroup';
import BtFailed from '../../components/BtFailed';
import { LandingScreen } from '../landing/landingScreen';
import { LANDING_SCREEN_PATH } from '../../support/routeConstants';
import BtLoading from '../../components/BtLoading';
import BtHelmet from '../../components/BtHelmet';
import BtCheckbox from '../../components/BtCheckbox';
import BtSpinner from '../../components/BtSpinner';
import { ContractCustomerScreen } from '../contractCustomer/contractCustomerScreen';

export const Apply: React.FC = () => {
  const viewModel = useAppSelector((state) => state.apply.viewModel);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [load, setLoading] = useState(false);
  const [state, setState] = useState({
    email: viewModel.state.email,
  });

  /*
    useEffect(() => {
        (async () => {
            dispatch(ApplyScreen.start(viewModel));
        })();
    }, [store.getState().appState.state]);
*/
  useEffect(() => {
    if (ApplyScreen.isNone(viewModel)) {
      dispatch(ApplyScreen.start(viewModel));
    } else if (ApplyScreen.isLoading(viewModel)) {
      (async () => {
        dispatch(await ApplyScreen.load(viewModel));
      })();
    }

    /*
                if (!store.getState().appState.state.sessionActive && ApplyScreen.isFailed(viewModel)) {
                    handleNavigate(LANDING_SCREEN_PATH)
                }
        */
  }, [viewModel]);

  const handleOnChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const target = event.target;
    const value = target.value;
    setState({ ...state, [target.name]: value });
    dispatch(await ApplyScreen.uppdateState(viewModel, event));
  };

  const handleNavigate = async (path: string) => {
    if (path.length === 0) {
      navigate(-1);
      dispatch(await ContractCustomerScreen.reset());
    } else {
      // dispatch(await LandingScreen.reset());
      navigate(path);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    dispatch(await ApplyScreen.apply(viewModel));
    setLoading(false);
  };

  if (ApplyScreen.isLoading(viewModel)) {
    return <BtLoading {...viewModel.loading} />;
  } else if (ApplyScreen.isReady(viewModel)) {
    return (
      <>
        <BtHelmet title={viewModel.metaTitle} />
        <BtSpinner {...viewModel.spinner} visible={false} show={load} onClick={() => {}} />
        <Container padding={0} size='xl'>
          <BtNavigate {...viewModel.navigation} onClick={handleNavigate} />
          <Container padding={0} maxW='container.md'>
            <Flex pb={200}>
              <VStack w='full' h='full' p={10}>
                <Heading as='h1' variant='h1' pb={5}>
                  {viewModel.greeting}
                </Heading>
                <Box w='100%' p={4} bg='black' borderRadius='lg' boxShadow='brand'>
                  <VStack spacing='1' w='100%' alignItems='start'>
                    {viewModel.customerItems !== null && (
                      <BtGroup items={viewModel.customerItems} />
                    )}
                    {!viewModel.state.canApply && (
                      <VStack w='100%' pb={8} alignItems='center'>
                        <Stack spacing={5} direction={['row', 'row']} alignItems='center'>
                          <Image src={images(viewModel.ikon)} />
                          <Link href={`tel:+${viewModel.supportNumber}`} color='brand.500'>
                            {viewModel.supportNumber}
                          </Link>
                        </Stack>
                      </VStack>
                    )}
                    <Text pl={5} opacity={!viewModel.state.canApply ? 0.4 : 1}>
                      {viewModel.complete}
                    </Text>
                    <Stack w='full' pl={5} pr={5} pt={5} spacing={8} direction={['column', 'row']}>
                      <BtInput {...viewModel.phone} onChange={handleOnChange} />
                      <BtInput {...viewModel.email} value={state.email} onChange={handleOnChange} />
                    </Stack>
                    <Box pl={5} w='100%'>
                      <Flex w='full'>
                        <Text pr='2' opacity={!viewModel.state.canApply ? 0.4 : 1}>
                          {viewModel.termsText}
                        </Text>
                        <BtButton variant='link' {...viewModel.terms} action={() => {}} />
                        <Spacer />
                      </Flex>

                      <BtCheckbox {...viewModel.agreeToTerms} onChange={handleOnChange} />
                    </Box>
                  </VStack>
                  <Stack p='5' spacing={2} direction={['column', 'column']}>
                    <BtButton
                      variant='primary'
                      size='lg'
                      w='full'
                      {...viewModel.apply}
                      action={() => handleApply()}
                    />
                  </Stack>
                </Box>
              </VStack>
            </Flex>
          </Container>
        </Container>
      </>
    );
  } else if (ApplyScreen.isFinish(viewModel)) {
    return (
      <Container padding={0} size='xl'>
        <BtNavigate {...viewModel.navigation} onClick={handleNavigate} />
        <Container padding={0} maxW='container.md'>
          <Flex pb={200}>
            <VStack w='full' h='full' p={10}>
              <Image src={images(viewModel.image)} />
              <Heading as='h1' variant='h1' textAlign='center' pb={5}>
                {viewModel.title}
              </Heading>

              <VStack spacing='5' w='100%'>
                <Stack
                  w='full'
                  spacing={5}
                  direction={['column', 'column']}
                  p={5}
                  alignItems='center'
                >
                  <Text align='center'>{viewModel.body}</Text>

                  {viewModel.id && (
                    <>
                      <Text align='center'>{viewModel.bookingId}</Text>
                      <Box
                        w='100%'
                        p={4}
                        bg='black'
                        borderRadius='lg'
                        border='1px solid rgba(255, 212, 163, 0.2)'
                      >
                        <Text as='h3' fontSize='3xl' align='center'>
                          {viewModel.id}
                        </Text>
                      </Box>
                    </>
                  )}
                </Stack>
              </VStack>
              <Box w='100%' p={5}>
                <BtButton
                  variant='primary'
                  size='lg'
                  w='full'
                  {...viewModel.ok}
                  action={() => handleNavigate(LANDING_SCREEN_PATH)}
                />
              </Box>
            </VStack>
          </Flex>
        </Container>
      </Container>
    );
  } else if (ApplyScreen.isDenied(viewModel)) {
    return (
      <Container padding={0} size='xl'>
        <BtNavigate {...viewModel.navigation} onClick={handleNavigate} />
        <Container padding={0} maxW='container.md'>
          <Flex pb={200}>
            <VStack w='full' h='full' p={10}>
              <Image src={images(viewModel.image)} />
              <Heading as='h1' variant='h1' textAlign='center' pb={5}>
                {viewModel.title}
              </Heading>

              <VStack spacing='5' w='100%'>
                <Stack
                  w='full'
                  spacing={5}
                  direction={['column', 'column']}
                  p={5}
                  alignItems='center'
                >
                  <Text align='center'>{viewModel.body}</Text>
                  <Stack spacing={5} direction={['row', 'row']} p={5} alignItems='center'>
                    <Image src={images(viewModel.ikon)} />
                    <Link href={`tel:+${viewModel.supportNumber}`} color='brand.500'>
                      {viewModel.supportNumber}
                    </Link>
                  </Stack>
                </Stack>
              </VStack>
              <Box w='100%' p={5}>
                <BtButton
                  variant='primary'
                  size='lg'
                  w='full'
                  {...viewModel.ok}
                  action={() => handleNavigate(LANDING_SCREEN_PATH)}
                />
              </Box>
            </VStack>
          </Flex>
        </Container>
      </Container>
    );
  } else if (ApplyScreen.isFailed(viewModel)) {
    return <BtFailed {...viewModel.error} />;
  } else {
    return <BtLoading {...viewModel.loading} />;
  }
};
